var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parasites"},_vm._l((3),function(i){return _c('img',{key:'parasites' + i,class:("opacity-" + i),style:([{width: _vm.width + 'px'}, {height: _vm.height + 'px'}]),attrs:{"alt":"parasites","src":_vm.getImage(i)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }